interface BaseSettings{
    configType: string,
    userId: number,
}

export interface NavigationSettings extends BaseSettings {
    debugMode: boolean,
    darkMode: boolean,
    isSideMenuOpen: boolean,
    isDrawerWider: boolean
}

export function setSettings(data: BaseSettings) {
    localStorage.setItem(data.configType + "_" + data.userId, JSON.stringify(data));
}

export function getSettings(configType: string, userId: number): BaseSettings | null {
    let settingString = localStorage.getItem(configType + "_" + userId.toString()) ?? null;
    if (settingString){
        return JSON.parse(settingString) as BaseSettings;
    }
    return null;
}